<template>
  <div>
    <v-card class="mb-3">
      <v-card-title>{{ $t('pages.customization.style') }}</v-card-title>
      <v-card-text>
        <template v-if="!platform.settings.disable_customization">
          <text-input
            :config="{ type: 'color', label: $t('pages.customization.labels.color.primary') }"
            v-model="colors.primary">
          </text-input>
          <text-input
            :config="{ type: 'color', label: $t('pages.customization.labels.color.secondary') }"
            v-model="colors.secondary">
          </text-input>
        </template>

        <headers-form
          v-if="platform.multi_experts"
          :value="headers"
          @input="x => headers = x">
        </headers-form>

        <v-switch :label="$t('pages.customization.labels.feedbacks')" v-model="feedbacks" dark></v-switch>
      </v-card-text>
      <v-card-row actions>
        <v-btn
          :loading="loading"
          @click.native.stop="saveSettings()"
          primary light block>
          {{ $t('pages.customization.save') }}
        </v-btn>
      </v-card-row>
    </v-card>
    <v-card>
      <v-card-title>{{ $t('pages.customization.links') }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item v-for="(link, i) in links" :key="i">
            <v-list-tile avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ link.title }} - {{ link.url }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn icon @click.native.stop="deleteLink({ id: link.id })">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-item>
        </v-list>

        <v-dialog
          v-model="modal" lazy>
          <v-btn
            slot="activator"
            outline primary>
            {{ $t('pages.customization.addLink') }}
          </v-btn>

          <v-card v-if="modal">
            <v-card-title>
              {{ $t('pages.customization.addLink') }}
            </v-card-title>
            <v-card-text>
              <link-creation @saved="onLinkSaved"></link-creation>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { TextInput, FileInput } from '@/components/inputs'
  import LinkCreation from '@/components/LinkCreation.vue'
  import HeadersForm from '@/components/HeadersForm.vue'
  export default {
    components: {
      TextInput,
      FileInput,
      LinkCreation,
      HeadersForm
    },
    data () {
      const platform = this.$store.getters['skiliko/session/currentPlatform']
      return {
        modal: false,
        colors: {
          primary: platform.settings.color.primary,
          secondary: platform.settings.color.secondary
        },
        headers: platform.settings.headers || [],
        feedbacks: platform.settings.feedbacks
      }
    },
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform',
        loading: 'skiliko/session/isLoading'
      }),
      links () {
        return this.platform.links
      },
      settings () {
        return {
          ...this.platform.settings,
          feedbacks: this.feedbacks,
          headers: this.headers,
          color: {
            primary: this.colors.primary,
            secondary: this.colors.secondary
          }
        }
      }
    },
    methods: {
      ...mapActions({
        savePlatform: 'skiliko/session/updateCurrentPlatform',
        deleteLink: 'skiliko/links/remove'
      }),
      saveSettings () {
        this.savePlatform({ data: {
          settings: JSON.stringify(this.settings)
        } })
      },
      onLinkSaved (link) {
        this.modal = false
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/Customization.vue